import {
    createSlice,
    createAsyncThunk,
    createEntityAdapter,
} from '@reduxjs/toolkit'
import { client } from '../../api/client'

const varFieldAttachmentsAdapter = createEntityAdapter({
    selectId: x => x.Id
})

const initialState = varFieldAttachmentsAdapter.getInitialState({
    status: 'idle',
    error: null,
})

export const fetchVarFieldAttachments = createAsyncThunk('varFieldAttachments/Get', async () => {
    const response = await client.get('/VarFieldAttachments')
    return response.data
})

const varFieldAttachmentsSlice = createSlice({
    name: 'varFieldAttachments',
    initialState,
    reducers: {},
    extraReducers: {
        [fetchVarFieldAttachments.pending]: (state, action) => {
            state.status = 'loading'
            state = undefined
        },
        [fetchVarFieldAttachments.fulfilled]: (state, action) => {
            state.status = 'succeeded'
            varFieldAttachmentsAdapter.addMany(state, action.payload)
        },
        [fetchVarFieldAttachments.rejected]: (state, action) => {
            state.status = 'failed'
            state.error = action.payload
        }
    },
})

export default varFieldAttachmentsSlice.reducer

export const {
    selectAll: selectAllVarFieldAttachments,
    selectById: selectVarFieldAttachmentsById,
} = varFieldAttachmentsAdapter.getSelectors((state) => state.varFieldAttachments)
